import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";

const PlanContext = createContext(null);
const PLAN_KEY = "veloclin_plan";

export const PLAN_INFO = {
  solo: { id: "solo", name: "Solo", price: "R$ 149", priceValue: 149 },
  basic: { id: "basic", name: "Basic", price: "R$ 399", priceValue: 399 },
  max: { id: "max", name: "Max", price: "R$ 899", priceValue: 899 },
};

export const PlanProvider = ({ children }) => {
  const [plan, setPlanState] = useState(() => {
    try {
      return localStorage.getItem(PLAN_KEY) || "basic";
    } catch (e) {
      return "basic";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(PLAN_KEY, plan);
    } catch (e) {
      // ignore
    }
  }, [plan]);

  const setPlan = useCallback((p) => setPlanState(p), []);

  const value = useMemo(
    () => ({ plan, setPlan, isMax: plan === "max", info: PLAN_INFO[plan] }),
    [plan, setPlan]
  );

  return <PlanContext.Provider value={value}>{children}</PlanContext.Provider>;
};

export const usePlan = () => {
  const ctx = useContext(PlanContext);
  if (!ctx) throw new Error("usePlan deve ser usado dentro de PlanProvider");
  return ctx;
};
